import React from 'react'
import ManageProspectForm from '../../../modules/ManageProspect/Form'

const Index = () => {
  return <ManageProspectForm caseType="edit" />
}
export default Index
